import React, {useEffect, useRef, useState} from 'react';
import Modal from '@mui/joy/Modal';
import Button from '@mui/joy/Button';
import ModalDialog from '@mui/joy/ModalDialog';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Box from '@mui/joy/Box';
import {CircularProgress, Divider} from "@mui/joy";

const CropModal = ({isModalOpen = false,
                       setIsModalOpen,
                       okAction,
                       imageToCrop="https://i.imgur.com/iiSnt2r.jpeg",
                       oldCrop}) => {

    const [crop, setCrop] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [image, setImage] = useState(null);
    const imgRef = useRef(null);

    useEffect(()=>{
        setCrop(currentCrop => ({ ...currentCrop, x: currentCrop.x + 0.01 }));
    },[isModalOpen])


    const cropImageNow = () => {
        const image = imgRef.current;

        if(!image) return;
        const multiplier = image.naturalWidth / image.width
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width * 2;
        canvas.height = crop.height * 2;
        const ctx = canvas.getContext('2d');

        const pixelRatio = window.devicePixelRatio;
        canvas.width = crop.width * multiplier;
        canvas.height = crop.height * multiplier;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * multiplier,
            crop.height * multiplier,
        );

        // Convert the canvas to a PNG image
        const base64Image = canvas.toDataURL('image/png');

        okAction(base64Image, crop, imageToCrop);
        // croppedImage(base64Image);
    };

    const handleImageLoaded = () => {
        setIsLoading(false);
        setCrop(oldCrop || {
            height: 112.80006408691406,
            unit: "px",
            width: 100,
            x: 22.99993896484375,
            y: 32.799957275390625,
        })
    }

    const handleOk = () => {
        cropImageNow();

        setIsModalOpen(false);

    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <ModalDialog
                aria-labelledby="nested-modal-title"
                aria-describedby="nested-modal-description"
                sx={(theme) => ({
                    width: '60vw',
                    height: '85vh',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    [theme.breakpoints.only('xs')]: {
                        top: 'unset',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        borderRadius: 0,
                        transform: 'none',
                        maxWidth: 'unset',
                    },
                })}
            >
                {isLoading && (
                    <Box sx={{width:'100%', height: '100%', display:'flex', alignItems:'end', justifyContent:'center'}}>
                        <CircularProgress />
                    </Box>
                )}
                <Box sx={{width:'100%', height: '100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    {imageToCrop && (
                        <ReactCrop
                            onImageLoaded={setImage}
                            crop={crop}
                            onChange={newCrop => setCrop(newCrop)}
                            style={{ maxHeight: "70vh", maxWidth: "60vw" }}
                        >
                            <img
                                src={imageToCrop}
                                ref={imgRef}
                                crossOrigin="anonymous"
                                onLoad={handleImageLoaded}
                                style={{ display: isLoading ? 'none' : 'block' }} // Hide image while loading
                            />
                        </ReactCrop>
                    )}
                </Box>
                <div style={{width:'100%'}} >
                    <Divider />
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            width:'100%',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={handleOk}>
                            Crop
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Box>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default CropModal;